import { observer } from 'mobx-react-lite';
import TeacherPostReviewDetailStore from './TeacherPostReviewDetailStore';
import { useStore } from 'hooks/useStore';
import { Box, IconButton, Stack } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import BackHandOutlinedIcon from '@mui/icons-material/BackHandOutlined';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const PostReviewActions = observer(() => {
  const { approve, reject, next } = useStore<TeacherPostReviewDetailStore>(
    'TeacherPostReviewDetailStore',
  );

  return (
    <Box flex={1}>
      <Stack direction="row" spacing={0.5} justifyContent="flex-end">
        <IconButton
          color="error"
          sx={{ flex: '0 0 auto', ml: 0 }}
          onClick={(e) => {
            e.stopPropagation();
            reject();
          }}
        >
          <BackHandOutlinedIcon />
        </IconButton>
        <IconButton
          color="primary"
          sx={{ flex: '0 0 auto', ml: 0 }}
          onClick={(e) => {
            e.stopPropagation();
            approve();
          }}
        >
          <DoneIcon />
        </IconButton>
        <IconButton
          color="primary"
          sx={{ flex: '0 0 auto', ml: 0 }}
          onClick={(e) => {
            e.stopPropagation();
            next();
          }}
        >
          <NavigateNextIcon />
        </IconButton>
      </Stack>
    </Box>
  );
});

export default PostReviewActions;
